import { render } from "./PageWrapper.vue?vue&type=template&id=87ddf28a&scoped=true&ts=true"
import script from "./PageWrapper.vue?vue&type=script&lang=ts"
export * from "./PageWrapper.vue?vue&type=script&lang=ts"

import "./PageWrapper.vue?vue&type=style&index=0&id=87ddf28a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ddf28a"]])

export default __exports__